import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Super Sizzling Curlew</title>
        <meta property="og:title" content="Super Sizzling Curlew" />
        <link
          rel="canonical"
          href="https://super-sizzling-curlew-lvmy3i.teleporthq.site/"
        />
      </Helmet>
      <Navigation
        text={
          <Fragment>
            <span className="home-text10">More</span>
          </Fragment>
        }
      ></Navigation>
      <main className="page-container">
        <section className="hero-section">
          <div className="hero-media-wrapper">
            <video
              autoPlay="true"
              muted="true"
              loop="true"
              playsInline="true"
              poster="https://images.pexels.com/videos/31575762/pictures/preview-0.jpg"
              src="https://videos.pexels.com/video-files/31575762/13456552_640_360_30fps.mp4"
              className="hero-video"
            ></video>
            <div className="hero-overlay"></div>
          </div>
          <div className="hero-content-container">
            <div className="hero-text-block">
              <h1 className="home-hero-title hero-title">Get Semester Done</h1>
              <p className="home-hero-subtitle hero-subtitle">
                Upload your syllabus and watch SylliPlan transform it into a
                daily roadmap. AI-powered study tools included.
              </p>
              <div className="hero-actions">
                <Link to="/syllabus-upload-planner">
                  <div className="home-thq-btn-elm1 btn btn-lg btn-primary">
                    <span>Start Planning Free</span>
                  </div>
                </Link>
                <Link to="/login">
                  <div className="home-thq-btn-elm2 btn btn-lg btn-outline">
                    <span>Log In</span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="features-section">
          <div className="features-container">
            <h2 className="section-title">Everything You Need To Ace It</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                      <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2m-5-10v6"></path>
                      <path d="M9.5 13.5L12 11l2.5 2.5"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="section-subtitle">Syllabus Upload</h3>
                <p className="section-content">
                  Simply drag and drop your PDF or DOCX syllabus. Our AI
                  extracts every deadline instantly.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                      <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                      <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                      <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                      <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                      <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="section-subtitle">AI Study Tool</h3>
                <p className="section-content">
                  Get personalized study guides and practice quizzes based on
                  your specific course material.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M11 10v4h4"></path>
                      <path d="m11 14l1.535-1.605a5 5 0 0 1 8 1.5M16 2v4m5 12l-1.535 1.605a5 5 0 0 1-8-1.5"></path>
                      <path d="M21 22v-4h-4m4-9.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3M3 10h4m1-8v4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="section-subtitle">Calendar Sync</h3>
                <p className="section-content">
                  Sync your generated plan with Google Calendar, iCal, or
                  Outlook in one click.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                      <path d="m19 9l-5 5l-4-4l-3 3"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="section-subtitle">Deadlines &amp; Reminders</h3>
                <p className="section-content">
                  Never miss a submission. Receive smart notifications before
                  major assignments are due.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M16 5H3m13 7H3m8 7H3m12-1l2 2l4-4"
                    ></path>
                  </svg>
                </div>
                <h3 className="section-subtitle">Progress Tracking</h3>
                <p className="section-content">
                  Visualize your semester journey. See how many tasks
                  you&apos;ve crushed and what&apos;s next.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                      <path d="m9 12l2 2l4-4"></path>
                    </g>
                  </svg>
                </div>
                <h3 className="section-subtitle">Automated Planner</h3>
                <p className="section-content">
                  We don&apos;t just list dates; we build a balanced daily
                  schedule that fits your life.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="process-section">
          <div className="process-container">
            <h2 className="section-title">From Syllabus to Success</h2>
            <div className="steps-wrapper">
              <div className="step-item">
                <div className="step-number">
                  <span>01</span>
                </div>
                <h3 className="section-subtitle">Upload</h3>
                <p className="section-content">
                  Drop your syllabus files into the platform.
                </p>
              </div>
              <div className="step-item">
                <div className="step-number">
                  <span>02</span>
                </div>
                <h3 className="section-subtitle">Generate</h3>
                <p className="section-content">
                  AI maps out every lecture, reading, and exam.
                </p>
              </div>
              <div className="step-item">
                <div className="step-number">
                  <span>03</span>
                </div>
                <h3 className="section-subtitle">Study</h3>
                <p className="section-content">
                  Use AI tools to break down complex topics.
                </p>
              </div>
              <div className="step-item">
                <div className="step-number">
                  <span>04</span>
                </div>
                <h3 className="section-subtitle">Execute</h3>
                <p className="section-content">
                  Follow your daily plan and hit your goals.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="demo-section">
          <div className="demo-media-wrapper">
            <img
              src="https://images.pexels.com/photos/5530515/pexels-photo-5530515.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              alt="Demo Background"
              className="demo-image"
            />
            <div className="demo-overlay"></div>
          </div>
          <div className="demo-content-container">
            <div className="demo-glass-card">
              <h2 className="section-title">See SylliPlan in Action</h2>
              <p className="section-content">
                Watch how we turn a 20-page syllabus into a manageable 15-week
                daily plan in under 60 seconds.
              </p>
              <button className="btn btn-accent btn-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path fill="currentColor" d="M8 5v14l11-7z"></path>
                </svg>
                <span>
                  {' '}
                  Watch Demo
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </button>
            </div>
          </div>
        </section>
        <section className="testimonials-section">
          <div className="testimonials-container">
            <h2 className="section-title">What Your Peers Are Saying</h2>
            <div className="testimonials-grid">
              <div className="testimonial-card">
                <p className="section-content">
                  &quot;SylliPlan literally saved my GPA. I used to spend the
                  first week of classes just trying to organize. Now it&apos;s
                  done in seconds.&quot;
                </p>
                <div className="testimonial-author">
                  <div className="author-info">
                    <span className="author-name">Sarah J.</span>
                    <span className="author-meta">Pre-Med Junior</span>
                  </div>
                </div>
              </div>
              <div className="testimonial-card">
                <p className="section-content">
                  &quot;The AI study tool is a game changer. It creates practice
                  tests that are so close to the real thing, it&apos;s
                  scary.&quot;
                </p>
                <div className="testimonial-author">
                  <div className="author-info">
                    <span className="author-name">Marcus T.</span>
                    <span className="author-meta">Engineering Sophomore</span>
                  </div>
                </div>
              </div>
              <div className="testimonial-card">
                <p className="section-content">
                  &quot;I finally stopped missing deadlines. The automated
                  reminders are the only reason I&apos;m passing my history
                  elective.&quot;
                </p>
                <div className="testimonial-author">
                  <div className="author-info">
                    <span className="author-name">Elena R.</span>
                    <span className="author-meta">History Major</span>
                  </div>
                </div>
              </div>
              <div className="testimonial-card">
                <p className="section-content">
                  &quot;Syncing with my Google Calendar was so easy. My entire
                  life is organized without me lifting a finger.&quot;
                </p>
                <div className="testimonial-author">
                  <div className="author-info">
                    <span className="author-name">David L.</span>
                    <span className="author-meta">Business Senior</span>
                  </div>
                </div>
              </div>
              <div className="testimonial-card">
                <p className="section-content">
                  &quot;As a first-gen student, this felt like having a personal
                  academic advisor in my pocket. Highly recommend!&quot;
                </p>
                <div className="testimonial-author">
                  <div className="author-info">
                    <span className="author-name">Aisha K.</span>
                    <span className="author-meta">Freshman</span>
                  </div>
                </div>
              </div>
              <div className="testimonial-card">
                <p className="section-content">
                  &quot;Improved my grades and reduced my stress. I actually
                  have time for a social life now.&quot;
                </p>
                <div className="testimonial-author">
                  <div className="author-info">
                    <span className="author-name">Liam W.</span>
                    <span className="author-meta">Computer Science</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="impact-section">
          <div className="impact-container">
            <h2 className="section-title">Real Results</h2>
            <div className="impact-grid">
              <div className="impact-card">
                <span className="impact-value">40+</span>
                <span className="impact-label">Hours Saved / Semester</span>
              </div>
              <div className="impact-card">
                <span className="impact-value">0.5</span>
                <span className="impact-label">Avg. GPA Improvement</span>
              </div>
              <div className="impact-card">
                <span className="impact-value">125k+</span>
                <span className="impact-label">Syllabi Processed</span>
              </div>
              <div className="impact-card">
                <span className="impact-value">50k+</span>
                <span className="impact-label">Active Students</span>
              </div>
            </div>
          </div>
        </section>
        <section className="cta-section">
          <div className="cta-container">
            <div className="cta-split">
              <div className="cta-content">
                <h2 className="section-title">Ready to crush your semester?</h2>
                <p className="section-content">
                  Join thousands of students who have automated their academic
                  success. Create your account today and get your first syllabus
                  plan for free.
                </p>
                <div className="cta-benefits">
                  <div className="benefit-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      No credit card required
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                  <div className="benefit-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      1-click syllabus import
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                  <div className="benefit-item">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20 6L9 17l-5-5"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      AI tools included
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className="cta-pricing-card">
                <div className="pricing-header">
                  <span className="pricing-plan">Pro Student</span>
                  <div className="pricing-price">
                    <span>
                      {' '}
                      $9.99
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span className="price-period">/semester</span>
                  </div>
                </div>
                <ul className="pricing-features">
                  <li>
                    <span>Unlimited Syllabus Uploads</span>
                  </li>
                  <li>
                    <span>Full Calendar Integration</span>
                  </li>
                  <li>
                    <span>Advanced AI Study Guides</span>
                  </li>
                  <li>
                    <span>Priority Support</span>
                  </li>
                </ul>
                <Link to="/syllabus-upload-planner">
                  <div className="home-thq-btn-elm4 btn btn-primary btn-xl">
                    <span>Get Started Now</span>
                  </div>
                </Link>
                <p className="pricing-footer">Or start with our Free tier</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div className="home-container2">
        <div className="home-container3">
          <Script
            html={`<script defer data-name="sylliplan-core">
(function(){
  const featureCards = document.querySelectorAll(".feature-card")
  const observerOptions = {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  }

  const revealOnScroll = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
        revealOnScroll.unobserve(entry.target)
      }
    })
  }, observerOptions)

  featureCards.forEach((card) => {
    card.style.opacity = "0"
    card.style.transform = "translateY(30px)"
    card.style.transition = "all 0.6s ease-out"
    revealOnScroll.observe(card)
  })

  const impactValues = document.querySelectorAll(".impact-value")
  const countUpObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const target = entry.target
        const finalValue = parseFloat(target.innerText.replace(/[^0-9.]/g, ""))
        const suffix = target.innerText.replace(/[0-9.]/g, "")
        let start = 0
        const duration = 2000
        const startTime = performance.now()

        const updateCount = (currentTime) => {
          const elapsed = currentTime - startTime
          const progress = Math.min(elapsed / duration, 1)
          const currentCount = (progress * finalValue).toFixed(finalValue % 1 === 0 ? 0 : 1)
          target.innerText = currentCount + suffix

          if (progress < 1) {
            requestAnimationFrame(updateCount)
          }
        }

        requestAnimationFrame(updateCount)
        countUpObserver.unobserve(target)
      }
    })
  }, observerOptions)

  impactValues.forEach((val) => countUpObserver.observe(val))
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Home
